module.exports = __webpack_public_path__ + "img/Deposit_Now_Icon.29ddd84.svg";